import $ from 'jquery';
import {smoothy} from "../Libraries/smoothy";


function updateCounts() {
    const $countElement = $('*[data-search-result-count]').first();
    if ($countElement.length > 0) {
        const count = parseInt($countElement.attr('data-search-result-count'));
        if (count) {
            $('.search-result-count').text(count);
        }
    }
}

$(document).on('click', '#load-more-results', ev => {
    ev.preventDefault();
    const $button = $(ev.currentTarget);
    const $spinner = $button.find('.spinner');
    const nextUrl = $button.attr('data-next-page');
    if (!nextUrl) {
        return;
    }

    (async () => {
        $button.prop('disabled', true);
        $spinner.removeClass('d-none');
        let resp = await fetch(nextUrl);
        let html = await resp.text();

        let bodyStart = html.indexOf('<body');
        bodyStart = html.indexOf('>', bodyStart) + 1;
        let bodyEnd = html.indexOf('</body>');
        let body = html.substring(bodyStart, bodyEnd);

        const $body = $(body);
        const $list = $body.find('.search-result-list');
        const $newButton = $body.find('#load-more-results');

        $('.search-result-list').append($list.html());

        if ($newButton.length > 0) {
            $button.attr('data-next-page', $newButton.attr('data-next-page'));
            $button.prop('disabled', false);
            $spinner.addClass('d-none');
        } else {
            $button.remove();
        }
    })();
});

$('.fancy-checkbox__check--project').each((i, elem) => {
    let $elem = $(elem);
    let $projectFilters = $elem.closest('.kesearch-filters').find('.project-filters').first();
    if ($projectFilters.length === 0) {
        console.warn('Could not find project filters');
        return;
    }

    function toggleProjectFilters() {
        if ($elem.prop('checked')) {
            $projectFilters.addClass('project-filters--show');
        } else {
            $projectFilters.removeClass('project-filters--show');
            $projectFilters.find('*[name]')
                .val('')
                .trigger('change');
        }
    }

    $elem.on('change', () => toggleProjectFilters());
    toggleProjectFilters();
});


let timeout = null;
/** @type {AbortController} */
let aborter = null;
$('.kesearch-filters *[name]').on('change', ev => {
    if (timeout !== null) {
        window.clearTimeout(timeout);
        timeout = null;
    }
    if (aborter !== null) {
        aborter.abort('cancelled');
        aborter = null;
    }

    let $elem = $(ev.currentTarget);
    let $form = $elem.closest('form');

    const $areas = $('.kesearch-result-list');
    $areas.addClass('blocked-area');

    timeout = window.setTimeout(() => {
        timeout = null;
        let formData = new FormData($form[0]);

        (async () => {

            try {
                const url = new URL($form.attr('action'), window.location.href);
                for (const pair of formData) {
                    url.searchParams.append(pair[0], pair[1]);
                }

                let resp;
                if ('AbortController' in window) {
                    aborter = new AbortController();
                    resp = await fetch(url, {signal: aborter.signal});
                } else {
                    resp = await fetch(url);
                }
                let html = await resp.text();

                try {
                    let $body = $(html.split(/<body[^>]*>/)[1].split(/<\/body>/)[0]);
                    let $newResults = $body.find('.kesearch-result-list');
                    let $oldResults = $('.kesearch-result-list');

                    $oldResults.replaceWith($newResults);
                    updateCounts();

                    history.pushState({}, '', url);
                } finally {
                    $areas.removeClass('blocked-area');
                }

            } finally {
                aborter = null;
            }
        })();

    }, 200);
});


(function () {
    updateCounts();
    if (
        location.search.indexOf('tx_kesearch_pi1%5Bsword%5D=test') > -1
        && location.hash === ''
    ) {
        smoothy(() => $('.kesearch-search-area').offset().top, 1000);
    }
})();
